import Fingerprint2 from 'fingerprintjs2'
import _ from 'lodash'

export const LS_DEVICE_FINGER_PRINT_KEY = 'DEVICE_FINGER_PRINT'

export function initFingerPrint () {
  Fingerprint2.get(function (components) {
    const values = components.map(function (component) {
      return component.value
    })
    const deviceFingerPrint = Fingerprint2.x64hash128(values.join(''), 31)
    window.localStorage.setItem(LS_DEVICE_FINGER_PRINT_KEY, deviceFingerPrint)
    window.localStorage.setItem('QR_CODE', deviceFingerPrint)
  })
}

export function getFingerPrint () {
  if (_.isNil(window.localStorage.getItem(LS_DEVICE_FINGER_PRINT_KEY))) {
    initFingerPrint()
  }
  const result = window.localStorage.getItem(LS_DEVICE_FINGER_PRINT_KEY)
  return result
}
